import React, { Component } from "react";
import { Button } from "semantic-ui-react";
import { connect } from "react-redux";
import { withTranslation } from "react-i18next";

class CallButton extends Component {
  render() {
    const { user_id } = this.props;
    let icon = "eye";
    if (this.props.connected) {
      icon = "close";
    }
    return (
      <Button
        title={this.props.t("WebCamUser.callLearner")}
        circular
        icon={icon}
        size={this.props.size}
        className={this.props.connected ? "flat-button flat-button-warning" : "flat-button flat-button-primary"}
        onClick={() => {
          if (this.props.connected) {
            this.props.stopVideoCall(user_id);
          } else {
            this.props.startVideoCall(user_id);
          }
        }}
      />
    );
  }
}

export default withTranslation()(
  connect(
    (state) => ({
      connected: state.session.faceToFaceConnected,
    }),
    {}
  )(CallButton)
);
